export const SliderFields = [
    {
        identifier: 'slider-background',
        type: 'input',
        field: 'slider-background'
    },
    { identifier: 'slider-previous', type: 'input', field: 'slider-previous' },
    { identifier: 'slider-next', type: 'input', field: 'slider-next' }
]
